import _ from 'underscore'
import Vue from 'vue'
import Ad from '../../resources/ad'
import DisplayAd from '../../resources/displayAd'

// This is an object where ads will be stored
// with keys as the id, and ad as the value
const state = {
  ads: [],
  displayAds: [],
}

const getters = {
  allAds(state) {
    return _.values(state.ads);
  },
  allDisplayAds(state) {
    return _.values(state.displayAds);
  },
}

const actions = {
  getAds(context) {
    Ad.query({}).then((res) => {
      context.commit(`RETRIEVE_AD_SUCCESS`, {ads: res.data})
    }, (res) => {
      Toast.error('Failed to retrieve ads')
    })
  },

  getDisplayAds(context) {
    console.log('Fetching display ads...')
    DisplayAd.query({}).then((res) => {
      context.commit(`RETRIEVE_DISPLAY_AD_SUCCESS`, { ads: res.data })
    }, (res) => {
      Toast.error('Failed to retrieve display ads')
    })
  },

  // payload.ad
  deleteAd(context, payload) {
    Ad.delete({id: payload.ad.id}).then((res) => {
      context.commit(`DELETE_AD_SUCCESS`, {ad: payload.ad});
    }, (res) => {
      Toast.error('Failed to delete ad')
    })
  },

  // payload.id, payload.changes
  updateAd(context, payload) {
    Ad.update({ id: payload.id }, payload.changes).then((res) => {
      context.commit(`UPDATE_AD_SUCCESS`, { ad: res.data });
      if (_.isFunction(payload.callback)) payload.callback();
    }, (res) => {
      Toast.error('Failed to save ad')
    })
  },

   createAd(context, payload) {
     Ad.save(payload.ad).then((res) => {
       context.commit('CREATE_AD_SUCCESS', {ad: res.data});
     }, (res) => {
       Toast.error('Failed to create ad')
     })
   },

}

const mutations = {

  RETRIEVE_AD_SUCCESS(state, payload) {
    _.each(payload.ads, (ad) => {
      Vue.set(state.ads, ad.id, ad);
    })
  },

  RETRIEVE_DISPLAY_AD_SUCCESS(state, payload) {
    _.each(payload.ads, (ad) => {
      Vue.set(state.displayAds, ad.id, ad);
    })
  },

  DELETE_AD_SUCCESS(state, payload) {
    Vue.delete(state.ads, payload.ad.id);
  },

  // payload.ad
  UPDATE_AD_SUCCESS(state, payload) {
    Vue.set(state.ads, payload.ad.id, payload.ad);
  },

  CREATE_AD_SUCCESS(state, payload) {
    Vue.set(state.ads, payload.ad.id, payload.ad);
  },

}



export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ads.js